<template>
  <div id="custom-preloader" class="container">
    <dy-loader style="scale:2;"></dy-loader>
    <!-- <div class="preloader-wrapper big active">
      <div class="spinner-layer spinner-blue-only">
        <div class="circle-clipper left">
          <div class="circle"></div>
        </div>

        <div class="gap-patch">
          <div class="circle"></div>
        </div>

        <div class="circle-clipper right">
          <div class="circle"></div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import Loader from "./Loader"
export default {
  components: {
    dyLoader: Loader
  }
}

</script>

<style scoped>
#custom-preloader {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner-blue-only {
  border-color: rgb(131, 68, 233);
}
</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue